import React, { useEffect, useState } from "react";
import InvoicePrintablePages from "./InvoicePrintablePages";
import axios from "axios";
import { handleGenericErrors, handleGenericSuccess } from "../../../utils/ErrorUtility";

interface Props {
	language: string;
	printClicked: boolean;
	handlePrint: Function;
}

export type InvoiceInfo = {
	invoiceNumber: string,
    invoiceDate: string,
	dueDate: string,
    fairId: string,
    bookfairAccountId: string,
    schoolName: string,
	province: string,
	isBogoFair: boolean,
    hostContactInformation: {
        name: string,
        email: string,
        phone: string,
    },	
	salesSummary: {
        cash: number,
        cheques: number,
        manualTransactions: number,
        wirelessTransactions: number,
        totalSales: number,
        taxes: number,
        netSales: number
    },	
    profitSelection: {
        productTakenOffTheFair: number,
        scholasticDollars: number,
        cash: number
    },
	rewardsSummary: {
		scholasticDollarsEligible: number,
		scholasticDollarsRate: number,
		productEligible: number,
		productRate: number,
		secondFairProductBonus: number,
		specialBonus: number
	},
	additionalProductTaken: {
        existingScholasticDollarBalance: number,
        additionalProductTakenOffTheFair: number
    },
	amountDue: {
		cash: number,
		cheques: number,
		deliveryFee: number,
		profitInCash: number,
		amountDue: number,
	}
};

export const defaultInvoiceInfo: InvoiceInfo = {
	invoiceNumber: "",
    invoiceDate: "",
	dueDate: "",
    fairId: "",
    bookfairAccountId: "",
    schoolName: "",
	province: "",
	isBogoFair: false,
    hostContactInformation: {
        name: "",
        email: "",
        phone: "",
    },
	salesSummary: {
        cash: 0,
        cheques: 0,
        manualTransactions: 0,
        wirelessTransactions: 0,
        totalSales: 0,
        taxes: 0,
        netSales: 0
    },
	rewardsSummary: {
		scholasticDollarsEligible: 0,
		scholasticDollarsRate: 0,
		productEligible: 0,
		productRate: 0,
		secondFairProductBonus: 0,
		specialBonus: 0
	},
    profitSelection: {
        productTakenOffTheFair: 0,
        scholasticDollars: 0,
        cash: 0
    },
	additionalProductTaken: {
        existingScholasticDollarBalance: 0,
        additionalProductTakenOffTheFair: 0
    },
	amountDue: {
		cash: 0,
		cheques: 0,
		deliveryFee: 0,
		profitInCash: 0,
		amountDue: 0,
	}
};

const RegisterInvoice = ({ language, printClicked, handlePrint }: Props) => {

	const [isLoading, setIsLoading] = useState(true);
	const [invoiceInfo, setInvoiceInfo] = useState<InvoiceInfo>(defaultInvoiceInfo);

	// get request for invoice
	useEffect(() => {
		axios
			.get(`${process.env.REACT_APP_ENV_BASE_URL}/api/user/fairs/current/financials/form/invoice`,{withCredentials: true,})
			.then((res) => {
				if(res.status === 200) {
					setInvoiceInfo(res.data);
				} else {
					handleGenericSuccess(res);
				}
			})
			.catch((error) => {
				handleGenericErrors(error);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, []);

	return (
		<>
			{!isLoading && 
				<InvoicePrintablePages
					language={language}
					printClicked={printClicked}
					handlePrint={handlePrint}
					invoiceInfo={invoiceInfo}
				/>
			}
		</>
	);
};

export default RegisterInvoice;
